module.exports = __webpack_public_path__ + "img/rotate-left.afbef11d.png";